{
  "chart": {
    "how-to-measure": "Jak měřit",
    "select-your-size-we-ll-notify-you-once-it-s-back-in-stock": "Vyberte svou velikost, dáme vám vědět, jakmile bude opět skladem"
  },
  "page": {
    "plans": {
      "try-now": "Vyzkoušet nyní",
      "what-included": "Co je zahrnuto?",
      "popular-plan": "Oblíbené"
    },
    "about-us": {
      "title": "O nás",
      "intro": "Goodchart vznikl v roce 2023 s posláním proměnit váš zážitek z nakupování oblečení. Náš tým nadšenců do módy, designérů a technologických expertů je tu, aby vám pomohl najít oblečení, které skutečně doplňuje vaše tělo. Díky uživatelsky přívětivému rozhraní a pokročilým algoritmům poskytujeme personalizovaná doporučení na základě vašich měr, stylu a životního stylu.",
      "community": "Rozlučte se s kompromisy a řekněte ano sebedůvěře a pohodlí. Připojte se k naší inkluzivní komunitě spokojených zákazníků a vydejte se s Goodchart na radostnou nákupní cestu.",
      "tagline": "Uvolněte svůj styl. Zažijte čistou módní euforii.",
      "founders": "Zakladatelé",
      "cedric-photo-alt": "Cedric, spoluzakladatel Goodchart a vedoucí produktu",
      "nick-photo-alt": "Nick, spoluzakladatel Goodchart a ředitel provozu",
      "quentin-photo-alt": "Quentin, vedoucí informačních technologií Goodchart",
      "cedric": "Cedric",
      "cedric-role": "Spoluzakladatel Goodchart a vedoucí produktu",
      "nick": "Nick",
      "nick-role": "Spoluzakladatel Goodchart a ředitel provozu",
      "quentin": "Quentin",
      "quentin-role": "Vedoucí informačních technologií Goodchart"
    },
    "contact": {
      "title": "Kontaktujte nás",
      "lets-talk": "Pojďme si promluvit",
      "subtitle": "Vyplňte formulář a náš tým se s vámi spojí e-mailem.",
      "first-name": "Jméno",
      "first-name-required": "Jméno je povinné",
      "last-name": "Příjmení",
      "last-name-required": "Příjmení je povinné",
      "email": "E-mail",
      "email-required": "E-mail je povinný",
      "email-invalid": "Zadejte prosím platnou e-mailovou adresu",
      "message": "Zpráva",
      "message-required": "Zpráva je povinná",
      "sending": "Odesílání...",
      "send": "Odeslat",
      "success": "Váš formulář byl odeslán našemu týmu!"
    },
    "email-unsubscribe": {
      "title": "E-mailové předplatné",
      "unsubscribe-confirm": "Opravdu se chcete odhlásit z odběru našeho seznamu adres?",
      "unsubscribe-info": "Po odhlášení již od nás nebudete dostávat novinky, newslettery a speciální nabídky.",
      "cancel": "Zrušit",
      "confirm-unsubscription": "Potvrdit odhlášení",
      "resubscribe-confirm": "Chtěli byste se znovu přihlásit k odběru našeho seznamu adres?",
      "resubscribe-info": "Zůstaňte v obraze s našimi nejnovějšími zprávami, exkluzivními nabídkami a zajímavými novinkami.",
      "resubscribe": "Znovu se přihlásit",
      "unsubscribe-success": "Odhlášení vašeho e-mailu proběhlo úspěšně",
      "unsubscribe-error": "Při odhlašování vašeho e-mailu došlo k problému",
      "resubscribe-success": "Opětovné přihlášení vašeho e-mailu proběhlo úspěšně",
      "resubscribe-error": "Při opětovném přihlašování vašeho e-mailu došlo k problému"
    },
    "back-to-stock": {
      "notify-me-product": "Upozornit mě na produkt {{title}} - {{variant}}"
    },
    "help": {
      "title": "Centrum nápovědy",
      "description": "Návody k nastavení a používání Goodchart ve vašem obchodě Shopify.",
      "search": "Hledat v článcích nápovědy",
      "loading": "Načítání…",
      "load-failed": "Centrum nápovědy se nepodařilo načíst. Zkuste to prosím za chvíli znovu.",
      "no-results": "Vašemu hledání neodpovídají žádné články.",
      "no-articles": "Zatím zde nejsou žádné články nápovědy.",
      "topics": {
        "getting-started": "Začínáme",
        "size-charts": "Tabulky velikostí",
        "table-charts": "Tabulkové přehledy",
        "assigning-products": "Přiřazení produktů",
        "storefront-display": "Zobrazení v obchodě",
        "chart-import": "Import tabulek",
        "size-recommendations": "Doporučení velikosti",
        "plans-billing": "Tarify a fakturace",
        "troubleshooting": "Řešení problémů"
      },
      "back": "Zpět do centra nápovědy",
      "browse": "Procházet centrum nápovědy",
      "not-found": {
        "title": "Článek nenalezen",
        "description": "Tento článek neexistuje nebo již není k dispozici."
      },
      "updated": "Naposledy aktualizováno {{date}}",
      "related": "Další v kategorii {{topic}}",
      "contact": {
        "title": "Stále potřebujete pomoc?",
        "description": "Pošlete nám zprávu a náš tým vám odpoví e-mailem. Pokud máte nainstalovanou aplikaci Goodchart, můžete se zeptat také v jejím chatu podpory.",
        "link": "Kontaktujte nás"
      },
      "article-load-failed": "Tento článek se nepodařilo načíst. Zkuste to prosím za chvíli znovu."
    }
  },
  "error": {
    "error-occurred": "Došlo k chybě!",
    "failed-to-subscribe-to-this-product": "Přihlášení k odběru tohoto produktu se nezdařilo!",
    "failed-to-get-your-size-recommendation-please-try-again-later": "Nepodařilo se získat doporučení velikosti. Zkuste to prosím později znovu."
  },
  "common": {
    "close": "Zavřít"
  },
  "component": {
    "size-recommender": {
      "form": {
        "title": "Najděte svou nejlepší velikost",
        "subtitle": "Několik rychlých údajů pro lepší padnutí",
        "shopping-for": "NAKUPUJI PRO",
        "gender-women": "Ženy",
        "gender-men": "Muže",
        "gender-other": "Jiné",
        "measurements": "MÍRY",
        "height": "Výška",
        "height-required": "Výška je povinná",
        "height-min": "Minimální výška je 1",
        "weight": "Hmotnost",
        "weight-required": "Hmotnost je povinná",
        "weight-min": "Minimální hmotnost je 1",
        "preferred-fit": "Preferovaný střih",
        "continue": "Pokračovat"
      },
      "result": {
        "suggested-size": "Doporučená velikost:",
        "no-fit": "Bohužel se zdá, že momentálně nemáme ideální velikost. Doporučujeme se vrátit později pro další možnosti.",
        "verdict": "Verdikt:",
        "similar-variants": "Podobné varianty:",
        "proceed": "Pokračovat s touto variantou",
        "estimate-disclaimer": "(Odhad založený na značce a údajích uživatele, výsledky se mohou lišit.)",
        "back": "Zpět"
      }
    },
    "footer": {
      "terms": "Podmínky",
      "privacy": "Soukromí",
      "help-center": "Centrum nápovědy",
      "blog": "Blog",
      "about": "O nás",
      "contact-us": "Kontaktujte nás"
    },
    "conversion-table": {
      "description": "V závislosti na střihu se mohou objevit mírné odchylky v míře. Najděte svou správnou velikost v tabulce níže.",
      "size": "Velikost"
    },
    "add-to-cart-btn": {
      "notify-me-when-available": "Upozornit mě, až bude dostupné",
      "notify-me": "Upozornit mě",
      "out-of-stock": "Není skladem"
    },
    "restock-form": {
      "your-name": "Vaše jméno",
      "your-email": "Vaše e-mailová adresa",
      "email-required": "E-mail je povinný",
      "subscribing": "Přihlašování...",
      "notify-me": "UPOZORNIT MĚ",
      "agree-terms": "Pokračováním souhlasíte s našimi",
      "terms-privacy": "Podmínkami a zásadami ochrany osobních údajů",
      "news-opt-in": "Rád(a) bych dostával(a) novinky o nových produktech a dalším inspirativním obsahu (volitelné)"
    },
    "back-to-stock-result": {
      "new-subscription": "Děkujeme, e-mail vám pošleme, jakmile bude velikost <span class=\"font-bold\">{{name}}</span> dostupná.",
      "existing-subscription": "Váš e-mail už máme! Dáme vám vědět, jakmile bude velikost <span class=\"font-bold\">{{name}}</span> opět skladem.",
      "back-to-collection": "Zpět na kolekci"
    },
    "chart": {
      "find-your-size": "Najděte svou velikost",
      "size-guide": "Tabulka velikostí",
      "recommendation": "Doporučení",
      "body-measurements": "TĚLESNÉ MÍRY",
      "model-measurements": "MÍRY MODELU",
      "model-description": "Model {{name}} měří {{height}}cm a nosí velikost {{variant}}.",
      "size-conversion": "PŘEVOD VELIKOSTÍ"
    },
    "landing": {
      "learn": "Naučit se",
      "learn-more": "Zjistit více",
      "blog": "Blog",
      "blog-description": "Prozkoumejte nejnovější oznámení, aktualizace produktů a další",
      "help-center": "Centrum nápovědy",
      "help-center-description": "Začínáme, návody a postupy krok za krokem",
      "demo": "Demo",
      "demo-description": "Podívejte se na widgety Goodsize v akci v naší ukázkové prodejně",
      "services": "SLUŽBY",
      "contact": "Kontakt",
      "privacy": "Soukromí",
      "goodsize": "Goodsize",
      "goodsize-description": "Objevte naše řešení pro velikosti pro vaše podnikání",
      "goodchart": "Goodchart",
      "goodchart-description": "Vizuální tabulka velikostí pro zvýšení konverze"
    },
    "product-variant-completer": {
      "title": "Vyberte své možnosti",
      "body": "Pokračujte výběrem {{option}}.",
      "body-multiple": "Pokračujte výběrem zbývajících možností.",
      "body-notify": "Kterou {{option}} máme pro vás hlídat?",
      "confirm": "Pokračovat",
      "cancel": "Zrušit",
      "empty": "Tato kombinace není dostupná."
    },
    "checkout-variant": {
      "label": "Kupujete {{variant}}",
      "aria-label": "Změnit kupovanou variantu",
      "sold-out": "vyprodáno"
    }
  },
  "promotion": {
    "BlackFriday": {
      "name": "Black Friday"
    }
  }
}
